import { ExportToCsv } from "export-to-csv";
import * as moment from "moment-timezone";
import { MenuOrderData } from "../../order/order.model";
import { TimeframeFilter } from "../../timeframe/timeframes";

export class MenuOrderExporter {
  public exporter: ExportToCsv;

  constructor(public orders: MenuOrderData[], public tf: TimeframeFilter) {}

  getFileName(): string {
    let begin = moment(this.tf.begin)
      .format("ll")
      .replace(", ", "")
      .replace(" ", "");
    let end = moment(this.tf.end)
      .format("ll")
      .replace(", ", "")
      .replace(" ", "");
    return "LineLeapDrinkOrders_" + begin + "-to-" + end;
  }

  public get options() {
    return {
      filename: this.getFileName(),
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: true,
      title: "Drink Orders",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };
  }

  toCSV(order: MenuOrderData, isAdmin: boolean) {
    let x = order.toCSV(isAdmin);
    return x;
  }
  export(isAdmin: boolean) {
    this.exporter = new ExportToCsv(this.options);
    let data = this.orders.map(order => this.toCSV(order, isAdmin));
    this.exporter.generateCsv(data);
  }
}
